var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIconInRedBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3552_7960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 39.942C31.0133 39.942 39.9417 31.0137 39.9417 20C39.9417 8.98633 31.0133 0.0579834 19.9996 0.0579834C8.98597 0.0579834 0.0576172 8.98633 0.0576172 20C0.0576172 31.0137 8.98597 39.942 19.9996 39.942Z",
    fill: "#FF6174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.434 26.9566C14.159 26.9563 13.8903 26.8746 13.6617 26.7217C13.4331 26.5688 13.255 26.3516 13.1498 26.0975C13.0446 25.8435 13.017 25.5639 13.0706 25.2942C13.1242 25.0245 13.2565 24.7767 13.4508 24.5821L24.5813 13.4517C24.845 13.2059 25.1939 13.0721 25.5543 13.0785C25.9147 13.0848 26.2586 13.2308 26.5136 13.4858C26.7685 13.7407 26.9145 14.0846 26.9208 14.445C26.9272 14.8055 26.7934 15.1543 26.5477 15.418L15.4172 26.5485C15.2885 26.6782 15.1353 26.7811 14.9666 26.8511C14.7978 26.9212 14.6168 26.957 14.434 26.9566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5642 26.9566C25.3814 26.957 25.2004 26.9212 25.0317 26.8511C24.8629 26.7811 24.7097 26.6782 24.581 26.5485L13.4506 15.418C13.2048 15.1543 13.071 14.8055 13.0774 14.445C13.0837 14.0846 13.2297 13.7407 13.4847 13.4858C13.7396 13.2308 14.0835 13.0848 14.4439 13.0785C14.8044 13.0721 15.1532 13.2059 15.4169 13.4517L26.5474 24.5821C26.7417 24.7767 26.874 25.0245 26.9276 25.2942C26.9812 25.5639 26.9536 25.8435 26.8484 26.0975C26.7432 26.3516 26.5651 26.5688 26.3365 26.7217C26.1079 26.8746 25.8392 26.9563 25.5642 26.9566Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3552_7960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconInRedBg);
export default __webpack_public_path__ + "static/media/cross-icon-in-red-bg.9c53771d987a5044680dafe91441db7e.svg";
export { ForwardRef as ReactComponent };